import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type {
	DocumentCatalogItem,
	PartInventoryItem,
} from "../models/Catalogs";

const DOCS_DB = import.meta.env.VITE_DOCS_DB || "docs_cmms";

type CatalogOptions = {
	/** Ignores the copy the API has stored and refreshes it with what the database says now. */
	invalidateCache?: boolean;
};

// The whole spare parts inventory. Every parts picker asks for exactly this, which is why it is
// worth loading once and sharing.
export const getPartsInventoryCatalog = async (
	options: CatalogOptions = {},
): Promise<PartInventoryItem[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "Search", value: null }];

	const resp = await apiService.callV3(
		"[MMS].[GetPartsInventory]",
		parameters,
		{ invalidateCache: options.invalidateCache },
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as PartInventoryItem[];
	}
	throw new Error(resp.message || "Error fetching the parts inventory");
};

export const getDocumentsCatalog = async (
	options: CatalogOptions = {},
): Promise<DocumentCatalogItem[]> => {
	const apiService = new MESApiService();
	// The same four the documents page sends with its filters cleared. IncludeObsolete is stated
	// even though the procedure defaults it to 0: the cache keys on the exact set of parameters, so
	// sending three instead of four stored a second, identical 14 MB copy.
	const parameters: spParameter[] = [
		{ name: "TreeId", value: null },
		{ name: "Search", value: null },
		{ name: "IncludeHistory", value: false },
		{ name: "IncludeObsolete", value: false },
	];

	const resp = await apiService.callV3(
		`[${DOCS_DB}].[DOCS].[GetDocumentsWeb]`,
		parameters,
		{ invalidateCache: options.invalidateCache },
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as DocumentCatalogItem[];
	}
	throw new Error(resp.message || "Error fetching the documents catalog");
};
